import { render } from "./TraitShopHeader.vue?vue&type=template&id=56375ebf"
import script from "./TraitShopHeader.vue?vue&type=script&lang=js"
export * from "./TraitShopHeader.vue?vue&type=script&lang=js"

import "./TraitShopHeader.vue?vue&type=style&index=0&id=56375ebf&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__